import HttpService from '../services/HttpService';

export const CHANGE_LANGUAGE = 'change_language';
export const UPDATE_USER_ROLE_TRANSLATIONS = 'update_user_role_translations';
export const UPDATE_SITE_LANGUAGES = 'update_site_languages';

export const getRoles = () => {
  return (dispatch) => {
    return gRT().then((data) => {
      dispatch({ type: UPDATE_USER_ROLE_TRANSLATIONS, payload: data });
    });
  };
};

export const getSiteLanguages = (force = false) => {
  return (dispatch, getState) => {
    const state = getState();
    if (!force && state.TranslationReducer.languages.length > 0) {
      return;
    }

    return gSL().then((data) => {
      // TODO: replace with next line when need multi-language system
      // const languages = data.languages;
      const languages = [data.languages[0]];
      dispatch({ type: UPDATE_SITE_LANGUAGES, payload: languages });
    });
  };
};

export const gRT = () => {
  return HttpService.get(`/admin/my-roles`)
    .then((response) => response.json())
    .then((data) => data);
};

export const gSL = () => {
  return HttpService.get('/site/languages')
    .then((response) => response.json())
    .then((data) => data);
};
